export default __webpack_public_path__ + "static/media/Dog Wash- Dog with Bubbles.0772e3e5.jpg";